module.exports = __webpack_public_path__ + "img/vero.2702c08d.png";